<template>
  <div class="menu-container">
    <template v-for="r in menuList">
      <template v-if="r.meta.showMenu ">
      <el-submenu :index="r.path" :key="r.path" v-if="r.children && r.children.length > 0">
        <template slot="title">
          <i :class="r.meta.icon"></i>
          <span>{{ r.meta.title }}</span>
        </template>
        <el-menu-item-group>
          <my-nav :menuList="r.children" />
        </el-menu-item-group>
      </el-submenu>

        <el-menu-item :index="r.path" @click.native="handleRoute(r)" :key="r.path" v-else>
          <i :class="r.meta.icon"></i>
          <span>{{ r.meta.title}}</span>
        </el-menu-item>
      </template>
    </template>
  </div>
</template>
  
  <script>
export default {
  name: "my-nav",
  props: {
    menuList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    handleRoute(r) {
      this.$router.push({ name: r.name });
    },
  },
};
</script>
  
  <style lang="scss">
.menu-container {
  .iconfont {
    margin-right: 6px !important;
  }
}
</style>
  